import * as React from 'react'
import {Suspense, useEffect, useState} from 'react'
import {Helmet} from 'react-helmet'
import InfoBlock from './components/infoBlock'
import TopBar from './components/topbar'
import './css/common.css'
import PageContent from './pageContent'
import AppProps from './util/appProps'
import {isSimplePage, TOPBAR_COLOR_ACCENT} from './util/util'

interface AppContext {
    topbarColor: any
    utmParameters: any
    setAboutIsMounted: (isMounted: boolean) => void
    setTopbarColor: (topbarColor) => void
}

export const AppContext = React.createContext<AppContext>({
    topbarColor: undefined,
    utmParameters: undefined,
    setAboutIsMounted: () => null,
    setTopbarColor: () => null
})

const App = (props: AppProps) => {

    const parseCookies = () => {
        const cookieStr = document.cookie
        let cookieObj: any = {}

        if (cookieStr) {
            cookieObj = cookieStr.split(/; */).reduce((obj, str) => {
                if (str === '') return obj
                const eq = str.indexOf('=')
                const key = eq > 0 ? str.slice(0, eq) : str
                let val = eq > 0 ? str.slice(eq + 1) : null
                if (val != null) {
                    try {
                        val = decodeURIComponent(val)
                    } catch (ex) {
                        /* pass */
                    }
                }
                obj[key] = val
                return obj
            }, {})
        }

        return cookieObj
    }

    const parseUtmParameters = () => {
        const locationStr = props.location.search.substring(1)
        let locationObj: any = {}

        if (locationStr) {
            const str = '{"' + decodeURI(locationStr).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
            locationObj = JSON.parse(str)
        }

        const isUtm = obj => obj.utm_source || obj.utm_content || obj.utm_campaign || obj.gclid || obj.utm_medium || obj.utm_term || obj.url

        if (isUtm(locationObj)) {
            localStorage.setItem('utm', JSON.stringify(locationObj))
        } else {
            const storageObj = JSON.parse(localStorage.getItem('utm') || '{}')

            if (isUtm(storageObj)) {
                locationObj = storageObj
            } else {
                const cookieObj = parseCookies()

                if (isUtm(cookieObj)) {

                    /* eslint-disable */
                    const utm_source = cookieObj.utm_source
                    const utm_content = cookieObj.utm_content
                    const utm_campaign = cookieObj.utm_campaign
                    const gclid = cookieObj.gclid
                    const utm_medium = cookieObj.utm_medium
                    const utm_term = cookieObj.utm_term
                    const url = cookieObj.url

                    const utm = {utm_source, utm_campaign, utm_content, utm_medium, utm_term, gclid, url}
                    /* eslint-enable */

                    localStorage.setItem('utm', JSON.stringify(utm))
                    locationObj = utm
                }
            }
        }

        return locationObj
    }

    const [about, setAbout] = useState(false)
    const [topbarColor, setTopbarColor] = useState(TOPBAR_COLOR_ACCENT)
    const [utmParameters, setUtmParameters] = useState({})

    useEffect(() => {
        props.history.listen((location) => {
            if (!location.hash) {
                window.scrollTo(0, 0)
            }
        })
        setUtmParameters(parseUtmParameters())
    }, [])

    const path = props.location.pathname

    useEffect(() => {
        setAbout(path.includes('/about'))
    }, [path])

    // const WaitingComponent = (Component) => {
    //     // eslint-disable-next-line react/display-name
    //     return props => (
    //         <Suspense fallback={<div>Loading...</div>}>
    //             <Component {...props} />
    //         </Suspense>
    //     )
    // }

    const simple = isSimplePage(path)

    return (
        <AppContext.Provider value={{
            topbarColor,
            utmParameters,
            setAboutIsMounted: (isMounted: boolean) => setAbout(isMounted),
            setTopbarColor: (topbarColor) => setTopbarColor(topbarColor)
        }}>
            <Helmet>
                <title>Persona.ly - Machine Learning Driven Mobile User Acquisition</title>
                <meta name="title" content="Persona.ly - Machine Learning Driven Mobile User Acquisition" />
                <meta name="description" content="Persona.ly is a tech product company driving mobile user acquisition for brands and app developers, operating world-wide. Using our proprietary bidder and machine-learning algorithms Persona.ly offers transparent, performance-based, highly-targeted app install and retargeting solutions" />
                <meta name="keywords" content="User Acquisition, Programmatic User Acquisition, Mobile UA, Mobile Monetization, Market Research" />
            </Helmet>
            {/* <Intercom appID="xi87eto6" /> */}
            {!simple && <Suspense fallback=""><TopBar {...props} /></Suspense>}
            {about && <div className="about-video-top"><video src="https://static.persona.ly/images/about/video_about.mp4" autoPlay loop playsInline muted /></div>}
            <Suspense fallback={<div style={{height: '100vh'}} />}>
                <PageContent {...props} />
            </Suspense>
            {!simple && <Suspense fallback=""><InfoBlock /></Suspense>}
        </AppContext.Provider>
    )
}

export default App


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app.tsx